export const BANK_ID_LOGIN = 'bankidlogin';
export const BANK_ID_REGISTRATION = 'bankidregistration';
